export default __webpack_public_path__ + "static/media/subLogo.2fced2a0.svg";